module.exports = __webpack_public_path__ + "img/nav.68c1589a.svg";